import { FC } from 'react';

import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from './tooltip';

interface SimpleTooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  contentClassName?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  /** Surface style: `default` (dark) or `light` (popover background — readable for rich content). */
  variant?: 'default' | 'light';
}

export const SimpleTooltip: FC<SimpleTooltipProps> = ({
  content,
  children,
  contentClassName,
  side,
  variant,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      {content && (
        <TooltipPortal>
          <TooltipContent className={contentClassName} side={side} variant={variant}>
            {content}
          </TooltipContent>
        </TooltipPortal>
      )}
    </Tooltip>
  );
};
